const url = {
  baseUrl: 'https://keycloak.technicise.eu',
  imageUploadUrl: 'https://medical-wisdom-his-webserver-720c729466fb.herokuapp.com',
  erpBaseUrl: 'https://erp-ssssh.technicise.eu',
}

export default url
